import { Routes, Route, Navigate } from 'react-router-dom'
import PortalApp from './portal/PortalApp'
import AdminApp from './admin/AdminApp'
import NotFound from './components/NotFound'

export default function App() {
  return (
    <Routes>
      <Route path="/c/:token/*" element={<PortalApp />} />
      <Route path="/admin/*" element={<AdminApp />} />
      <Route path="/" element={<Navigate to="/admin" replace />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}
